import { Socket } from './config';

export const getIntentions = async function() {
    const response = await fetch(`${Socket.endpoint}&key=${Socket.key}`);
    const json = await response.json();

    let data = json;

    return data;
}